import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as _ from "lodash";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import moment from "moment/moment";
import config from "../../app/config";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { isChild } from "./admitPatient";
import AgyleTextField from "../../components/ui/fields/agyleTextField";
import { useSelector } from "react-redux";
import { user } from "../../store/reducers/user";
import Formatter from "../../util/formatter";

const useStyles = makeStyles((theme) => ({
  body: {
    width: "90%",
    margin: "30px 5% 5% 5%",
  },
  content: {
    padding: 20,
    margin: 20,
  },
  bodyTitle: {
    // paddingLeft: 20
    fontSize: 18,
  },
  title: {
    textAlign: "center",
    width: "100%",
  },
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  search: {
    // position: 'relative',
    borderRadius: theme.shape.borderRadius,
    //backgroundColor: theme.palette.background.paper,
    "&:hover": {
      // backgroundColor: theme.palette.background.,
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
    // marginTop: '20px',
    width: "60% !important",
    left: "20%",
    position: "fixed",
    marginTop: "-64px",
    fontSize: 20,
    textAlign: "center",
    // backgroundColor: 'rgb(54 54 54)' //theme.palette.background.default // '#252525'
    //   backgroundColor: theme.palette.mode === 'light' ? '#cecece' : '#363636'
  },

  searchInput: {
    padding: "20px 0 20px 0",

    "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
      paddingLeft: " 40px !important",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    //height: '100%',
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.primary.mainColor,
    marginLeft: 0,
    marginTop: 8,
  },
  fullName: {
    display: "inline-block",
    marginLeft: 10,
    fontWeight: 300,
  },
  familyName: {
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: 5,
  },
  vvip: {
    color: "#e46060",
    border: "1px solid #e46060",
    padding: "3px",
    fontSize: "10px",
    marginRight: "6px",
    borderRadius: "16px",
    verticalAlign: "middle",
    display: "inline-block",
    height: "20px",
  },
  patientsTable: {},
  searchButtons: {
    textAlign: "center",
  },
  tableHeader: {
    backgroundColor: theme.palette.mode === "light" ? "#e2e2e2" : "#363636",
    padding: "5px",
    marginBottom: "7px",
    color: "gray",
    fontSize: 12,
  },
  tableRecord: {
    padding: "8px",
    marginBottom: "7px",
    backgroundColor: theme.palette.mode === "light" ? "#cacaca" : "#434343",
    // backgroundColor: "rgb(67 67 67)",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.default.main,
    },
  },
  pagination: {
    width: "fit-content",
    margin: "auto",
  },
  fullNameHeader: {
    marginLeft: "10px",
  },
  sortedHeader: {
    cursor: "pointer",
  },
  buttonSelector: {
    borderRadius: 50,
    backgroundColor: theme.palette.grey["300"],
    color: "rgba(0, 0, 0, 0.87)",
    margin: "0 5px",
    fontSize: 10,
  },
  headerText: {
    float: "left",
    marginTop: 4,
  },
  formControl: {
    width: "100%",
  },
  next: {
    width: "50%",
    margin: "auto",
  },
  error: {
    color: "#f44336",
  },
  patientHeaderItem: {
    fontSize: 14,
    verticalAlign: "top",
    lineHeight: "24px",
    display: "inline-block",
    margin: "0 5px",
    backgroundColor: theme.palette.background.paper,
    padding: "2px 7px",
    borderRadius: 5,
    "& .label": {
      marginRight: 5,
      fontSize: "90%",
    },
    "& .value": {
      fontWeight: "bold",
    },
  },
}));
const Summary = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { admit, admission, bedBooking, bedBookingForm, isBedBookingChosen, temporaryPatientRef, isAddOnlyPatient } =
    props;

  const patientAge = moment().diff(admit.dob, "years");

  // SECTIONS
  const demographicsSection = [
    {label: "First Name", value: admit.firstName, key: "firstName", type: "text"},
    {label: "Middle Name", value: admit.middleNames, key: "middleNames", type: "text"},
    {label: "Family Name", value: admit.familyName, key: "familyName", type: "text"},
    {label: "Gender", value: admit.gender?.__description, key: "gender", type: "text"},
    {label: "Hospital Number", value: admit.hospitalNumber, key: "hospitalNumber", type: "text"},
    {label: "NHS Number", value: admit.nhsNumber, key: "nhsNumber", type: "text"},
    {label: "Date of Birth", value: admit.dob?.format(config?.defaultDateFormat), key: "dateOfBirth", type: "text"},
    {label: "Age", value: patientAge, key: "age", type: "text"},
    {label: "Overseas Status", value: admit.overseasStatus?.__description, key: "overseasStatus", type: "text"},
    {label: "Ethnic Group", value: admit.ethnicGroup?.__description, key: "ethnicGroup", type: "text"},
    {label: "Ehic Number", value: admit.ehicCard ? admit.ehicNumber : "", key: "ehicNumber", type: "text"},
    {label: "Reason for not providing EHIC Number", value: !admit.ehicCard ? admit.noEhicReason : "", key: "noEhicReason", type: "text"},
    {label: "Occupation", value: admit.occupation, key: "occupation", type: "text"},
    {label: "Street", value: admit.street, key: "street", type: "text"},
    {label: "Building", value: admit.building, key: "building", type: "text"},
    {label: "City", value: admit.city, key: "city", type: "text"},
    {label: "Post Town", value: admit.postTown, key: "postTown", type: "text"},
    {label: "County", value: admit.county, key: "county", type: "text"},
    {label: "Postal Code", value: admit.postalCode, key: "postalCode", type: "text"},
    {label: "Email Address", value: admit.emailAdresses, key: "emailAddresses", type: "array"},
    {label: "Phone number", value: admit.phoneNumbers, key: "phoneNumbers", type: "array"},
    {label: "Employer Name", value: admit.employerName, key: "employerName", type: "text"},
    {label: "Employer Address", value: admit.employerAddress, key: "employerAddress", type: "text"},
    {label: "Employer Postal Code", value: admit.employerPostalCode, key: "employerPostalCode", type: "text"},
  ];

  const nextOfKinSection = {
    label: "Next of Kin",
    value: admit.nokList,
    key: "nokList",
    type: "array"
  };

  const childSection = [
    {label: "School Name", value: admit.schoolName, key: "schoolName", type: "text"},
    {label: "School Contact", value: admit.schoolContact, key: "schoolContact", type: "text"},
    {label: "School Address", value: admit.schoolAddress, key: "schoolAddress", type: "text"},
    {label: "School Postal Code", value: admit.schoolPostalCode, key: "schoolPostalCode", type: "text"},
    {label: "CP-IS", value: admission.cpIs, key: "cpIs", type: "boolean"},
    {label: "CP-IS Alert Present", value: admission.cpIsAlertPresent, key: "cpIsAlertPresent", type: "boolean"},
  ]

  const attendanceSection = [
    {label: "Chief Complaint", value: admission.chiefComplaint?.__description, key: "chiefComplaint", type: "text"},
    {label: "Arrival Mode", value: admission.modeOfArrival?.snomedDescription, key: "modeOfArrival", type: "text"},
    {label: "Attendance Source", value: admission.attendanceSource?.__description, key: "attendanceSource", type: "text"},
    {label: "Location", value: admission.location?.__description, key: "location", type: "text"},
    {label: "Attendance Type", value: admission.attendanceType?.__description, key: "attendanceType", type: "text"},
    {label: "Emergency Care Attendance Category", value: admission.attendanceCategory?.__description, key: "attendanceCategory", type: "text"},
    {label: "Ambulance Incident Number", value: admission.ambulanceIncidentNumber, key: "ambulanceIncidentNumber", type: "text"},
    {label: "Care Contact Identifier", value: admission.careContactIdentifier, key: "careContactIdentifier", type: "text"},
    {label: "Org Id - Conveying Ambulance Trust", value: admission.conveyingAmbulanceOrgId, key: "conveyingAmbulanceOrgId", type: "text"},
    {label: "History of Presenting Complaint", value: admission.historyOfPresentingComplaint, key: "historyOfPresentingComplaint", type: "text"},
    {label: `${config.gpExpected ? "GP Expected" : "111"} Flag`, value: admission.flag111, key: "flag111", type: "boolean"},
    {label: `${config.gpExpected ? "GP Expected" : "111"} Flag Date`, value: admission.flag111Timestamp, key: "flag111Timestamp", type: "date"},
    {label: "Major Trauma", value: admission.majorTraumaFlag, key: "majorTraumaFlag", type: "boolean"},
  ];

  const getBedBookingAlarms = () => {
    let alarms;
    if (bedBooking) {
      if (bedBooking.alarms && !_.isEmpty(bedBooking.alarms[0])) {
        alarms = bedBooking.alarms[0];
      }
    }

    return alarms;
  };

  const renderBedBookingFields = (field, label, string) => {
    const getVal = (value) => {
      if (string) return value;
      else return value ? `Yes` : `No`;
    };

    if (bedBookingForm) {
      const form = _.cloneDeep(bedBookingForm);
      const note = form[`${field}Note`];
      const user = form[`${field}User`];

      let valueText = field === "requested" ? user : getVal(form[field]);

      if (field === "ward") {
        valueText = form[field]?.wardName || "";
      }

      return (
        <>
          <Grid item xs={12} md={6}>
            <AgyleTextField
              fullWidth
              disabled
              label={label}
              value={valueText}
            />
          </Grid>
          {note && (
            <Grid item xs={12} md={6}>
              <AgyleTextField
                fullWidth
                disabled
                label={`${label} Note`}
                value={note}
              />
            </Grid>
          )}
        </>
      );
    }
  };

  const getActivityTreatment = () => {
    let activityTreatment;
    if (!bedBookingForm.activityTreatment) {
      return;
    }
    activityTreatment = bedBookingForm.activityTreatment;

    return (
      <Grid item xs={12} md={6}>
        <AgyleTextField
          fullWidth
          disabled
          label="Activity Treatment"
          value={activityTreatment.__description}
        />
      </Grid>
    );
  }

  const getSdecSite = () => {
    let site;
    if (!bedBooking.sdecSite){
      return;
    }
    site = bedBooking.sdecSite

    return (
        <Grid item xs={12} md={6}>
            <AgyleTextField
                fullWidth
                disabled
                label="Zone"
                value={site.__description}
            />
        </Grid>
    );
  }

  const getCurrentSite = () => {
    let site;
    if (!bedBooking.currentSiteBedBooking){
      return;
    }
    site = bedBooking.currentSiteBedBooking

    return (
        <Grid item xs={12} md={6}>
            <AgyleTextField
                fullWidth
                disabled
                label="Patient Location"
                value={site.__description}
            />
        </Grid>
    );
  }

  const renderDemographicSection = () => {
    return demographicsSection.map(field => {
      return field.type === "array" &&
        !_.isEmpty(field.value) &&
        field.value.length > 0
        ? field.value.map((singleArrayField, index) => {
            const key =
              field.key === "emailAddresses" ? "emailAddress" : "number";
            const textValue =
              key === "emailAddress"
                ? singleArrayField[key]
                : `${singleArrayField[key]} - ${singleArrayField["type"]}`;

            return (
              <Grid item xs={12} md={6} key={field.key + index}>
                <AgyleTextField
                  onChange={() => console.warn("Cannot change")}
                  fullWidth
                  disabled
                  value={textValue}
                  label={field.label}
                />
              </Grid>
            );
          })
        : !_.isArray(field.value) && !!field.value && (
            <Grid item xs={12} md={6} key={field.key}>
              <AgyleTextField
                onChange={() => console.warn("Cannot change")}
                fullWidth
                disabled
                value={field.value}
                label={field.label}
              />
            </Grid>
          );})
  }

  const renderNextOfKinSection = () => {
    return (
        !_.isEmpty(nextOfKinSection.value) && nextOfKinSection.value.map((field, index) => {
          const {city, county, firstName, lastName, phoneNumber, postTown, postalCode, relationship, street} = field;
          const fieldLabel = {
            city: "City",
            county: "County",
            firstName: "First Name",
            lastName: "Last Name",
            phoneNumber: "Phone Number",
            postTown: "Post Town",
            postalCode: "Postal Code",
            relationship: "Relationship",
            street: "Street"
          }

          const getFieldLabel = key => fieldLabel[key];
          const getFieldValue = key => key === "relationship" ? _.capitalize(field[key]?.__description) : field[key] ? field[key] : "NR";

          return (
            <>
              <Grid item xs={12}>
                <Divider textAlign="left">
                  {t(`Next of Kin no. ${index + 1}`)}
                </Divider>
              </Grid>
              <Grid item xs={12} md={6} key={field.key + index + "1"}>
                <AgyleTextField
                  onChange={() => console.warn("Cannot change")}
                  fullWidth
                  label={getFieldLabel("firstName")}
                  value={getFieldValue("firstName")}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6} key={field.key + index + "2"}>
                <AgyleTextField
                  onChange={() => console.warn("Cannot change")}
                  fullWidth
                  label={getFieldLabel("lastName")}
                  value={getFieldValue("lastName")}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6} key={field.key + index + "3"}>
                <AgyleTextField
                  onChange={() => console.warn("Cannot change")}
                  fullWidth
                  label={getFieldLabel("relationship")}
                  value={getFieldValue("relationship")}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6} key={field.key + index + "4"}>
                <AgyleTextField
                  onChange={() => console.warn("Cannot change")}
                  fullWidth
                  label={getFieldLabel("phoneNumber")}
                  value={getFieldValue("phoneNumber")}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6} key={field.key + index + "5"}>
                <AgyleTextField
                  onChange={() => console.warn("Cannot change")}
                  fullWidth
                  label={getFieldLabel("postalCode")}
                  value={getFieldValue("postalCode")}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6} key={field.key + index + "6"}>
                <AgyleTextField
                  onChange={() => console.warn("Cannot change")}
                  fullWidth
                  label={getFieldLabel("street")}
                  value={getFieldValue("street")}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6} key={field.key + index + "7"}>
                <AgyleTextField
                  onChange={() => console.warn("Cannot change")}
                  fullWidth
                  label={getFieldLabel("city")}
                  value={getFieldValue("city")}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6} key={field.key + index + "8"}>
                <AgyleTextField
                  onChange={() => console.warn("Cannot change")}
                  fullWidth
                  label={getFieldLabel("postTown")}
                  value={getFieldValue("postTown")}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6} key={field.key + index + "9"}>
                <AgyleTextField
                  onChange={() => console.warn("Cannot change")}
                  fullWidth
                  label={getFieldLabel("county")}
                  value={getFieldValue("county")}
                  disabled
                />
              </Grid>
            </>
          );}
        )
    )
  }

  const renderChildSection = () => {
    return childSection.map((field, index) => {
      const fieldValue = field.type === 'boolean' ? field.value ? 'Yes' : 'No' : field.value

      return (
          !!field.value && <Grid item xs={12} md={6} key={field.key + index}>
            <AgyleTextField
                onChange={() => console.warn("Cannot change")}
                fullWidth
                disabled
                value={fieldValue}
                label={field.label}
                />
          </Grid>
      )
    })
  }

  const renderAttendanceSection = () => {
    return attendanceSection.map((field, index) => {
        const fieldValue = field.type === 'boolean' ? field.value ? 'Yes' : 'No' : field.type === 'date' ? moment(field.value).format(config?.defaultDateTimeFormat) : field.value

        return (
          !!field.value && (
            <Grid item xs={12} md={6} key={field.key + index}>
              <AgyleTextField
                onChange={() => console.warn("Cannot change")}
                fullWidth
                disabled
                value={`${fieldValue}`}
                label={field.label}
              />
            </Grid>
          )
        );
    })
  }

  return (
    <Paper>
      <div className={classes.content}>
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ my: 2 }}>
            <Divider textAlign="center">
              <Typography variant="h6">Patient Demographics</Typography>
            </Divider>
          </Grid>

          {renderDemographicSection()}

          {renderNextOfKinSection()}

          {/*CHILD DETAILS SECTION*/}
          {admit.dob &&
            isChild(patientAge) && (admission.cpIs || admission.cpIsAlertPresent || admit.schoolName || admit.schoolAddress || admit.schoolPostalCode || admit.schoolAddress) && (
              <>
                <Grid item xs={12} sx={{ mt: 1 }}>
                  <Divider textAlign="left">Details</Divider>
                </Grid>

                {renderChildSection()}
              </>
            )}

          {/*  ADMISSION SECTION  */}
          {!isAddOnlyPatient && <Grid item xs={12} sx={{ m: 2 }}>
            <Divider textAlign="center">
              <Typography variant="h6">
                {t(
                  isBedBookingChosen
                    ? "Bed Booking Details"
                    : "Attendance Details"
                )}
              </Typography>
            </Divider>
          </Grid>}

          {isBedBookingChosen ? (
              <>
                {!_.isEmpty(getBedBookingAlarms()) &&
                    getBedBookingAlarms().map((alarm, index) => {
                      return (
                          <Grid item xs={12} md={6} key={alarm.name+index}>
                            <AgyleTextField
                                fullWidth
                                disabled
                                label={alarm.name}
                                value={_.startCase(alarm.state)}
                            />
                          </Grid>
                      );
                    })}

                {renderBedBookingFields("requested", "Requested By")}
                {renderBedBookingFields("sideRoom", "Side Room")}
                {renderBedBookingFields("patientPost", "Patient Post Take Complete")}
                {renderBedBookingFields("anotherDestination", "Site bed is requested at", true)}
                {renderBedBookingFields("allocated", "Allocated")}
                {renderBedBookingFields("ward", "Ward")}

                {getCurrentSite()}
                {getSdecSite()}
                {getActivityTreatment()}
              </>
          ) : (renderAttendanceSection())
          }

        </Grid>
      </div>
    </Paper>
  );
};

export default Summary;
